import React, { useState, useEffect } from "react";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

import ProductSlide from "../../../component/bundleList/productSlider";
import InstallationRequirement from "../../../component/bundleList/installationRequirement";
import Button from "../../../common/button";
import { useStateValue } from "../../../store";

import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const ProductDetail = (props) => {
  const {
    data,
    description,
    index,
    handleSelectedVariant,
    handleDefaultVariant,
    handleAddCart,
    allSelectedVariant,
    activeStep,
  } = props;
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedObject, setSelectedObject] = useState({});
  const [selectedToken, setSelectedToken] = useState("");
  const Navigate = useNavigate();
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    if (data?.variants?.length && selectedAttribute?.length) {
      let tempSeletecVariant = [];
      data.variants.map((variant) => {
        let isFound = null;
        variant?.variation_attributes?.length &&
          variant.variation_attributes.map((variantAttribute) => {
            if (
              isFound !== false &&
              selectedAttribute.includes(variantAttribute?.option_name)
            ) {
              isFound = true;
            } else {
              isFound = false;
            }
          });
        if (isFound) {
          tempSeletecVariant.push({
            ...variant,
            // variation_attributes: null,
          });
        }
      });
      if (tempSeletecVariant?.length === 1) {
        setSelectedVariant({ ...tempSeletecVariant[0] });
      } else {
        setSelectedVariant(null);
      }
    } else {
      setSelectedVariant(null);
    }
  }, [selectedAttribute]);

  useEffect(() => {
    if (selectedVariant !== null) {
      if (selectedToken === "loaded") {
        handleDefaultVariant({ index, selectedVariant });
        setSelectedToken("");
      } else {
        handleSelectedVariant({ index, selectedVariant });
      }
    }
  }, [selectedVariant]);

  useEffect(() => {
    const objKeys = Object.keys(selectedObject);
    if (objKeys?.length) {
      const arr = [];
      objKeys.map((keyValue, ind) => {
        if (selectedObject?.[keyValue]) {
          arr.push(selectedObject[keyValue]);
        }
      });
      setSelectedAttribute(arr);
    }
  }, [selectedObject]);

  useEffect(() => {
    const objKeys = Object.keys(selectedObject);
    if (objKeys?.length === 0 && data?.attributes) {
      let temp = {};
      setSelectedToken("loaded");
      Object.entries(data.attributes).map(([category, options]) => {
        // let tempType = "";
        // if (
        //   category?.split("__")[1] === "image" ||
        //   category?.split("__")[1] === ""
        // ) {
        //   tempType = "image";
        // } else if (category?.split("__")[1] === "select") {
        //   tempType = "select";
        // } else if (category?.split("__")[1] === "button") {
        //   tempType = "button";
        // } else if (category?.split("__")[1] === "color") {
        //   tempType = "color";
        // }
        if (options?.length) {
          temp[category] = options[0]?.option_name;
        }
      });
      setSelectedObject(temp);
    }
  }, []);

  const handleNavigate = () => {
    dispatch({
      type: "SET_CART_ALERT",
      value: false,
      data: {},
    });
    Navigate(`${process.env.REACT_APP_BASE}/bundle-listing`);
  };

  // Format as currency with CAD currency symbol
  const formattedPrice = (price) => {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
    }).format(price);
  };

  return (
    <div className="bundle-product-detail-container">
      {activeStep === index ? (
        <>
          <ProductSlide
            data={
              data?.carousel_images?.length
                ? data?.carousel_images
                : [data?.product_image]
            }
          />
          <div
            className="silder-description"
            dangerouslySetInnerHTML={{ __html: data?.short_description }}
          />
          <div className="product-detail-block">
            <div className="product-section">
              <div
                className="image"
                onClick={() =>
                  Navigate(`${process.env.REACT_APP_BASE}/product-details`)
                }
              >
                <img
                  src={
                    selectedVariant !== null
                      ? selectedVariant?.variation_image
                      : data?.product_image
                  }
                  alt={`products ${index}`}
                />
              </div>
              <div className="product-detail">
                <h3
                  onClick={() =>
                    Navigate(`${process.env.REACT_APP_BASE}/product-details`)
                  }
                >
                  {data?.product_name}
                </h3>
                {Object.entries(data?.attributes)?.map(
                  ([category, options]) => {
                    return (
                      <div key={category} className="selection">
                        {/* image attribute */}
                        {(category?.split("__")[1] === "image" ||
                          category?.split("__")[1] === "") && (
                          <>
                            <h2>
                              {category?.split("__")[0]}:{" "}
                              <span className="selected-value">
                                {selectedObject?.[category]}
                              </span>
                            </h2>
                            <div className="accessory">
                              {options?.map((option) => (
                                <p
                                  key={option.option_name}
                                  className="accessory-image"
                                >
                                  {option?.option_image && (
                                    <img
                                      className={`${
                                        selectedObject?.[category] ===
                                        option?.option_name
                                          ? "active"
                                          : ""
                                      }`}
                                      src={option?.option_image}
                                      alt={option?.option_name}
                                      onClick={() => {
                                        const temp = { ...selectedObject };
                                        temp[category] = option?.option_name;
                                        setSelectedObject(temp);
                                      }}
                                    />
                                  )}
                                </p>
                              ))}
                            </div>
                          </>
                        )}

                        {/* color attribute */}
                        {category?.split("__")[1] === "color" && (
                          <>
                            <h2>
                              {category?.split("__")[0]}:{" "}
                              <span className="selected-value">
                                {selectedObject?.[category]}
                              </span>
                            </h2>
                            <div className="accessory">
                              {options?.map((option) => {
                                return (
                                  <p
                                    key={option.color}
                                    className="accessory-image"
                                  >
                                    {option?.color && (
                                      <p
                                        className={`${
                                          selectedObject?.[category] ===
                                          option?.option_name
                                            ? "active"
                                            : ""
                                        }`}
                                        style={{
                                          backgroundColor: option?.color,
                                          padding: "18px",
                                          borderRadius: "50px",
                                          boxShadow: "inset 0 0 5px #cdcbcb",
                                        }}
                                        onClick={() => {
                                          const temp = { ...selectedObject };
                                          temp[category] = option?.option_name;
                                          setSelectedObject(temp);
                                        }}
                                      ></p>
                                    )}
                                  </p>
                                );
                              })}
                            </div>
                          </>
                        )}
                        {/* dropdown attribute */}
                        {category?.split("__")[1] === "select" && (
                          <>
                            <h2>{category?.split("__")[0]}</h2>
                            <div className="accessory">
                              <Select
                                labelId="simple-select-label"
                                id="simple-select"
                                value={
                                  selectedObject?.[category]
                                    ? selectedObject?.[category]
                                    : ""
                                }
                                placeholder="Choose an option"
                                className="auto-dropdown"
                                onChange={(event) => {
                                  const temp = { ...selectedObject };
                                  temp[category] = event.target?.value;
                                  setSelectedObject(temp);
                                }}
                              >
                                {options?.map((option) => {
                                  return (
                                    <MenuItem value={option?.option_name}>
                                      {option?.option_name}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </div>
                          </>
                        )}

                        {/* button attribute */}
                        {category?.split("__")[1] === "button" && (
                          <>
                            <h2>
                              {category?.split("__")[0]}:{" "}
                              <span className="selected-value">
                                {selectedObject?.[category]}
                              </span>
                            </h2>
                            <p className="btn-attribute">
                              {options?.map((option, index) => {
                                return (
                                  <>
                                    {option?.option_name && (
                                      <Button
                                        className={`${
                                          selectedObject?.[category] ===
                                          option?.option_name
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          const temp = { ...selectedObject };
                                          temp[category] = option?.option_name;
                                          setSelectedObject(temp);
                                        }}
                                      >
                                        {option?.option_name}
                                      </Button>
                                    )}
                                  </>
                                );
                              })}
                            </p>
                          </>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            </div>
            <div className="total-price">
              <p>Total price:</p>
              <p>
                <span>
                  {formattedPrice(allSelectedVariant?.[index]?.display_price)}{" "}
                  CAD
                </span>
              </p>
            </div>

            {/* <InstallationRequirement
              data={{
                description: description?.product_recommended_description,
                title: description?.product_recommended_title,
              }}
              checked={false}
            />
            <InstallationRequirement
              data={{
                description: description?.installation_requirements_description,
                title: description?.installation_requirements_title,
              }}
              checked={false}
            /> */}
            <div className="add-bundle-btn">
              <Button onClick={() => handleAddCart()}>
                Add product to cart
              </Button>
              <p onClick={() => handleNavigate()}>Not interested</p>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ProductDetail;
